module.exports = __webpack_public_path__ + "static/media/Group 79.87fa8b7e.svg";